import $$ from 'cmn-utils'

const baseUrl = "/api/safety/task/position/";
export default {
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
    submitTemplateSubject: (params) => {
        return $$.post(baseUrl + 'submit-template-subject', params)
    },
}